
const HonorsSummary = () => {
  const honors = [
    {
      icon: 'ri-time-line',
      title: '始于1716',
      description: '三百年历史传承',
      color: 'text-accent'
    },
    {
      icon: 'ri-government-line',
      title: '政府采购',
      description: '中央政府采购供应商',
      color: 'text-accent'
    },
    {
      icon: 'ri-award-line',
      title: '国宾伴手礼',
      description: '上海合作组织指定',
      color: 'text-accent'
    },
    {
      icon: 'ri-plant-line',
      title: '生态认证',
      description: '有机茶园认证',
      color: 'text-accent'
    },
    {
      icon: 'ri-star-line',
      title: '工艺大师',
      description: '非遗制茶技艺传承',
      color: 'text-accent'
    },
    {
      icon: 'ri-global-line',
      title: '国际荣誉',
      description: '多项国际茶叶大奖',
      color: 'text-accent'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-gray-50">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            品牌荣耀
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            三百年传承，现代荣誉见证，马帮瑞贡以品质赢得信赖
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 lg:gap-6">
          {honors.map((honor, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-4 lg:p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-100"
            >
              <div className="w-12 h-12 mx-auto mb-3 bg-accent/10 rounded-full flex items-center justify-center">
                <i className={`${honor.icon} text-lg ${honor.color}`}></i>
              </div>
              <h3 className="text-base font-bold text-primary font-serif mb-2">
                {honor.title}
              </h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                {honor.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 lg:mt-16 text-center">
          <div className="flex flex-wrap justify-center items-center gap-3 lg:gap-8 opacity-60">
            <div className="flex items-center space-x-1 lg:space-x-2">
              <i className="ri-shield-check-line text-lg text-primary"></i>
              <span className="text-xs font-medium text-primary">质量认证</span>
            </div>
            <div className="flex items-center space-x-1 lg:space-x-2">
              <i className="ri-truck-line text-lg text-primary"></i>
              <span className="text-xs font-medium text-primary">全国配送</span>
            </div>
            <div className="flex items-center space-x-1 lg:space-x-2">
              <i className="ri-customer-service-line text-lg text-primary"></i>
              <span className="text-xs font-medium text-primary">专业服务</span>
            </div>
            <div className="flex items-center space-x-1 lg:space-x-2">
              <i className="ri-refund-line text-lg text-primary"></i>
              <span className="text-xs font-medium text-primary">品质保证</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HonorsSummary;
